import React from "react";
import { Link } from "react-router-dom";
import "../CART/CSS/CartHero.css";
import bannerImg from "../CART/IMAGES/Rectangle 1 (2).png";

const CheckoutHero = () => {
  return (
    <div className="conatct-banner">
      <img src={bannerImg} alt="conatct-banner" />

      <div className="conatct-overlay">
        <h1>Checkout</h1>
        <p>
          <Link to="/">Home</Link> <span>›</span>{" "}
          <span className="conatct-active">Checkout</span>
        </p>
      </div>
    </div>
  );
};

export default CheckoutHero;
